<template>
  <div class="content_section select_plan">
                <div class="group_info">
                  <h2>SELECT PLAN</h2>
                  <form class="" action="index.html" method="post">
                    <div class="input_box">
                      <label for="">Select Plan <span class="red">*</span></label>
                      <div class="inputs">
                        <input type="text" name="" value=""/>
                      </div>
                    </div>
                    <div class="buttonbox">
                      <button @click="navigatePrevious" class="previous" type="button" name="button">Previous</button>
                      <button @click="saveAndContinue" class="next" type="button" name="button">Next</button>
                    </div>
                  </form>
                </div>
              </div>
</template>
<script>
export default {
    name: "SelectPlan",
    props: {
      navdata: {
        type: Array
      }
    },
    methods: {
      saveAndContinue() {
        //Update APIs
        //Navigate to next page
        this.$emit('comEnvNavigation', this.$route.name);
      },
      navigatePrevious() {
        //Update APIs
        //Navigate to next page
        this.$emit('comEnvNavigationBack', this.$route.name);
      },
    }
  }
</script>
